import {
   getHackedAndFraudSipUserIdsFromDevice,
   getHackedOrFraudExtensionNamesFromDevice,
   getIsFraudFromDevice,
   getIsHackedFromDevice,
} from '../../device-register/helpers/devices-helper';
import { DeviceDetailView } from '../models/device-detail-view.model';
import { GetDeviceDetail_device } from '../queries/generated/getDeviceDetail';

export function convertDeviceDetailsListItem(getDeviceItem: GetDeviceDetail_device): DeviceDetailView {
   return {
      account: getDeviceItem?.account || null,
      ztStatus: getDeviceItem.ztStatus,
      createDate: getDeviceItem.createDate || null,
      createUser: getDeviceItem.createUser?.name || null,
      deviceId: getDeviceItem.deviceId,
      deviceTypeId: getDeviceItem.deviceTypeId || null,
      deviceModel: getDeviceItem.deviceTypeId,
      description: getDeviceItem.description || null,
      macAddress: getDeviceItem.macAddress || null,
      serialNumber: getDeviceItem.serialNumber || null,
      lastFirmwareReported: getDeviceItem.lastFirmwareReported || null,
      phone: getDeviceItem.phone || null,
      baseStationHandsetsConnection: getDeviceItem.baseStationHandsetsConnection.items || null,
      extensionsConnection: getDeviceItem.account?.extensionsConnection.items || null,
      lastProvisionedDate: getDeviceItem.lastProvisionedDate || null,
      lastZtResponse: getDeviceItem.lastZtResponse || null,
      notes: getDeviceItem.notes || null,
      updateDate: getDeviceItem.updateDate || null,
      updateUser: getDeviceItem.updateUser?.name || null,
      isHacked: getIsHackedFromDevice(getDeviceItem) || null,
      isFraud: getIsFraudFromDevice(getDeviceItem) || null,
      hackedAndFraudSipUserIds: getHackedAndFraudSipUserIdsFromDevice(getDeviceItem) || null,
      hackedOrFraudExtension: getHackedOrFraudExtensionNamesFromDevice(getDeviceItem) || null,
   };
}
